<template>
  <section class="mx-3 lg:mx-0 max-w-screen-2xl">
    <div class="mt-10 lg:w-3/5 mx-auto">
      <div v-if="isLoading">
        <div class="flex items-center justify-center w-full h-screen -mt-32">
          <spinner />
        </div>
      </div>

      <div v-else>
        <div class="border-main rounded-lg mb-8">
          <div class="border-b" id="settingsTourItem1">
            <p
              class="lg:px-10 px-3 text-root-2 bg-gray-132 font-bold text-base lg:py-6 py-3"
            >
              Personal Information
            </p>
          </div>
          <div
            class="lg:px-8 px-3 py-2 lg:py-3 flex flex-row items-center lg:gap-x-6 gap-x-3 mb-3"
          >
            <div>
              <el-avatar
                class="flex items-center justify-center bg-black-2"
                :size="80"
              >
                {{
                  currentCustomerDetails.customerName.charAt(0).toUpperCase()
                }}
              </el-avatar>
            </div>
            <div>
              <p class="font-normal text-fg-muted text-13px mb-1">Name</p>
              <p class="font-normal text-fg-muted text-base">
                {{ currentCustomerDetails.customerName }}
              </p>
            </div>
          </div>
          <div
            class="mt-7 lg:px-10 px-3 md:flex items-center lg:gap-x-52 gap-x-3 pb-8"
          >
            <div class="pb-3 md:pb-0">
              <p class="font-normal text-fg-muted text-13px mb-1">Email</p>
              <p class="font-normal text-fg-muted text-base">
                {{ currentCustomerDetails.email }}
              </p>
            </div>
            <div>
              <p class="font-normal text-fg-muted text-13px mb-1">
                Phone Number
              </p>
              <p class="font-normal text-fg-muted text-base">
                {{ currentCustomerDetails.mobileNumber }}
              </p>
            </div>
          </div>
        </div>
        <div class="border-main rounded-lg mb-8">
          <div class="border-b">
            <p
              class="lg:px-10 px-3 text-root-2 font-bold bg-gray-132 text-base lg:py-6 py-3"
            >
              Customer Information
            </p>
          </div>
          <div class="mt-10 md:flex items-center lg:px-10 px-3 pb-8">
            <div class="w-1/2 pb-3 md:pb-0">
              <p class="font-normal text-fg-muted text-13px mb-2">
                Customer Id
              </p>
              <div class="flex items-center gap-x-2">
                <p class="font-normal text-black-10 text-base">
                  {{ maskID(currentCustomerDetails.id) }}
                </p>
                <span
                  class="cursor-pointer mb-1 ml-2"
                  v-clipboard:copy="currentCustomerDetails.id"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >
                  <copy-icon />
                </span>
              </div>
            </div>

            <div class="w-1/2">
              <p class="font-normal text-fg-muted text-13px mb-2">
                Partners Reference
              </p>
              <div class="flex items-center gap-x-2">
                <p class="font-normal text-black-10 text-base">
                  {{ currentCustomerDetails.reference }}
                </p>
                <span
                  class="cursor-pointer mb-1 ml-2"
                  v-clipboard:copy="currentCustomerDetails.reference"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >
                  <copy-icon />
                </span>
              </div>
            </div>
          </div>
          <div class="md:mt-6 mt-3 md:flex items-center lg:px-10 px-3 pb-8">
            <div class="w-1/2 pb-3 md:pb-0">
              <p class="font-normal text-fg-muted text-13px mb-2">
                Business Type
              </p>
              <p class="font-normal text-black-10 text-base">
                {{ currentCustomerDetails.type || '--' }}
              </p>
            </div>

            <div class="w-1/2">
              <p class="font-normal text-fg-muted text-13px mb-2">
                Date Onboarded
              </p>
              <p class="font-normal text-black-10 text-base">
                {{ displayTimeDate }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { MaskID, ParseLocalTime } from '@/utils/helpers'
import app from '@/mixins/app.js'

export default {
  mixins: [app],
  data () {
    return {
      isLoading: false
    }
  },
  components: {
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue'),
    Spinner: () => import('@/components/v2/app/Spinner.vue')
  },
  computed: {
    currentCustomerDetails () {
      return this.$store.state.externalApi.customerDetails
    },
    displayTimeDate () {
      const timeToPick = this.currentCustomerDetails?.createdAt

      return this.tooltipDateContent(timeToPick)
    }
  },
  methods: {
    parseLocalTime (time) {
      return ParseLocalTime(time)
    },
    maskID (val) {
      return MaskID(val)
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    }
  }
}
</script>

<style scoped>
>>> .el-avatar {
  font-size: 30px;
  border: 3px solid var(--border-main);
  background: rgba(1, 5, 44, 0.8);
}
</style>
